import { makeAutoObservable } from 'mobx';
import { toDisplayLicenseState } from 'features/eiq-secure/heplers/license-plate-recognition-state';

export interface ILincesePlateRecognitionData {
  licensePlate: string;
  licenseState: string;
  gate: string;
  camera: string;
  image?: string;
  recognitionId?: string;
}

// Currently it stores only last recognition value. Probably we will need to implement QUEUE for multiple recognitions.
class LicensePlateRecognitionContext {
  recognitionData: ILincesePlateRecognitionData | null = null;
  externalConsumptionVersion: number = 0;

  constructor() {
    makeAutoObservable(this);
    this.recognitionData = null;
  }

  set(data: ILincesePlateRecognitionData) {
    this.recognitionData = data;
  }

  clear() {
    this.recognitionData = null;
  }

  clearByExternalConsumption() {
    this.recognitionData = null;
    this.externalConsumptionVersion++;
  }

  get data() {
    return this.recognitionData;
  }

  getRecognitionId(gate?: string | null, licensePlate?: string | null, licenseState?: string | null): string | undefined {
    if (!gate || !licensePlate || !licenseState) {
      return undefined;
    }

    const data = this.recognitionData;
    if (!data?.recognitionId) {
      return undefined;
    }

    if (
      this.normalizeValue(data.gate) !== this.normalizeValue(gate) ||
      this.normalizeValue(data.licensePlate) !== this.normalizeValue(licensePlate) ||
      this.normalizeLicenseState(data.licenseState) !== this.normalizeLicenseState(licenseState)
    ) {
      return undefined;
    }

    return data.recognitionId;
  }

  private normalizeValue(value: string) {
    return value.trim().toUpperCase();
  }

  private normalizeLicenseState(value: string) {
    return this.normalizeValue(toDisplayLicenseState(value) ?? value);
  }
}

const plateRecognitionContext = new LicensePlateRecognitionContext();
export default plateRecognitionContext;
